import React from 'react';
import api from "@/services/api";
import { useSelector } from "react-redux";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';

const ModalUAM = ({question, getQuestion, setShowModalUAM, showModalUAM, setAlert, id }) => {
	const { dict } = useSelector(state => state.app);

	const handleUAM = async () => {
		try {
			const {data} = await api.put(`/questions/${question.id}/send`, {content: question.content, textFragment: question.textFragment});
			if(data) {
				getQuestion(id);
				setAlert({content: dict.simpleTextAdvices.modalUAM.alert, variant: 'success'});
			}
		} catch (error) {
			console.log(error);
		}
	};
	
	const handleClose = () => {
		setShowModalUAM(false);
	};
	
	return (
		<ModalWrapperChildren
			onClose={ handleClose }
			setModalVisible={ setShowModalUAM }
			modalVisible={ showModalUAM }
			onConfirm={ handleUAM }
			closeButtonName={ dict.cancel }
			confirmButtonName={ dict.simpleTextAdvices.modalUAM.confirm }
			title={ dict.simpleTextAdvices.modalUAM.title }
			preTitle={ dict.simpleTextAdvices.modalUAM.preTitle }
			description={ dict.simpleTextAdvices.modalUAM.description }
		>
		</ModalWrapperChildren>
	);
};

export default ModalUAM;